import { render } from "./InstagramFeeds.vue?vue&type=template&id=35b53746&scoped=true"
import script from "./InstagramFeeds.vue?vue&type=script&lang=js"
export * from "./InstagramFeeds.vue?vue&type=script&lang=js"

import "./InstagramFeeds.vue?vue&type=style&index=0&id=35b53746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b53746"]])

export default __exports__